const useTelegramWebAppLink = () => {
  const config = useRuntimeConfig();

  const getBotUsername = (): string => {
    return config.public.notificationBotName;
  };

  const createTelegramWebAppLink = (projectUrl: string): string => {
    const botUsername = getBotUsername();
    const encodedUrl = btoa(projectUrl);

    return `https://t.me/${botUsername}?startapp=${encodedUrl}`;
  };

  return {
    createTelegramWebAppLink,
    getBotUsername,
  };
};

export { useTelegramWebAppLink };
